import React from 'react'
import Spinner from '../shared/Spinner'

const SpinnerView = () => {
  return (
    <div className="spinnerView">
      <Spinner />
    </div>
  )
}

export default SpinnerView
